import React from 'react';
import { Button } from '@applane/react-core-components';
import { crossIconPng } from '../images';
import { View, Image } from '../app-components';
import { ROUTES } from '../Lib/constants';

const failTheme = {
  boundary: {
    width: 600,
    border: '2px solid white',
    height: 400,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  messageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    color: 'red',
  },
  doneButtonContainer: {
    width: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 0px',
  },
  closeButtonContainer: {
    width: 'inherit',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    padding: '5px 5px',
  },
  closeButtonStyle: {
    padding: '5px',
    color: 'red',
    textDecoration: 'underline',
  },
  doneButtonStyle: {
    backgroundColor: 'blue',
    color: 'white',
    width: '200px',
    textAlign: 'center',
    borderRadius: '20px',
    padding: '5px 0px',
  },
};

export const FailMessage = ({ navigation }) => {
  const handleClick = () => {
    navigation.reset(ROUTES.dealerData.name);
    navigation.navigate(ROUTES.ViewDealer.name, {
      item: { _id: navigation?.state?.params?.dealerId },
    });
  };

  return (
    <View style={failTheme.boundary}>
      <View style={failTheme.closeButtonContainer}>
        <Button style={failTheme.closeButtonStyle} onClick={handleClick}>
          <Image source={crossIconPng} style={{ width: 15, height: 15 }} />
        </Button>
      </View>
      <View style={failTheme.messageContainer}>Payment Failed</View>
      <View style={failTheme.doneButtonContainer}>
        <Button style={failTheme.doneButtonStyle} onClick={handleClick}>
          OK
        </Button>
      </View>
    </View>
  );
};
